import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: -999;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 100vw;
    height: 80rem;
    overflow-x: hidden;
  }
`;

export const Design1 = styled.div`
  position: absolute;
  width: 90rem;
  height: 90rem;
  left: 1.8rem;
  top: -16.9rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(246, 33, 225, 0.3) 0%, rgba(246, 33, 225, 0) 100%);
  filter: blur(20rem);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    position: absolute;
    width: 48.204rem;
    height: 48.205rem;
    left: -20.2rem;
    top: 3.6rem;

    background: radial-gradient(50% 50% at 50% 50%, rgba(246, 33, 225, 0.3) 0%, rgba(246, 33, 225, 0) 100%);
    filter: blur(200px);
  }
`;
export const Design2 = styled.div`
  position: absolute;
  width: 70rem;
  height: 70rem;
  left: 40rem;
  top: 12.6rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 195, 246, 0.3) 0%, rgba(33, 195, 246, 0) 100%);
  filter: blur(20rem);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    position: absolute;
    width: 42.849rem;
    height: 42.849rem;
    left: 14.936rem;
    top: 12.812rem;

    background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.3) 0%, rgba(33, 246, 80, 0) 100%);
    filter: blur(200px);
  }
`;
export const Design3 = styled.div`
  position: absolute;
  width: 80rem;
  height: 80rem;
  left: 67.4rem;
  top: 0.3rem;

  background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.3) 0%, rgba(33, 246, 80, 0) 100%);
  filter: blur(20rem);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    position: absolute;
    width: 37.493rem;
    height: 37.493rem;
    left: 0.26rem;
    top: 19.4rem;

    background: radial-gradient(50% 50% at 50% 50%, rgba(33, 195, 246, 0.3) 0%, rgba(33, 195, 246, 0) 100%);
    filter: blur(200px);
  }
`;
export const Design4 = styled.div`
  position: absolute;
  width: 78.2rem;
  height: 78.2rem;
  left: -26.7rem;
  top: 181.8rem;

  background: radial-gradient(50% 50% at 50% 50%, #21f650 0%, #2d5981 65.62%, rgba(0, 0, 0, 0) 100%);
  opacity: 0.4;
  filter: blur(20rem);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;

export const Design5 = styled.div`
  position: absolute;
  width: 134.8rem;
  height: 134.8rem;
  left: 106.5rem;
  top: 196.5rem;

  background: radial-gradient(50% 50% at 50% 50%, #21f650 0%, rgba(0, 0, 0, 0) 100%);
  opacity: 0.3;
  filter: blur(20rem);
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    display: none;
  }
`;
